import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';

// 工具方法，需要的时候在开启，默认不开启，省流量
export * from './date';
export * from './track';
// export * from './auth';
// export * from './download';

/**
 * 深度克隆简单对象
 * @param {*} obj
 */
export function cloneDeepPlainObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}


/**
 * 判断当前时间是否在时间范围内
 * @param { Array } range 时间范围
 */
export function hasInTimeRange(range) {
  const now = new Date();
  const h = getHours(now);
  const m = getMinutes(now);
  const time = h * 60 + m;
  if (time >= range[0] && time <= range[1]) {
    return true;
  } else {
    return false;
  }
}
/**
 * 获取url参数
 * @param { Array } range 时间范围
 */
export function geturlParams(){
  let searchParams = location.href.split("?")[1];
  let obj = {}
  if(searchParams){
    let arr  =  searchParams.split("&");
    arr.forEach((item)=>{
      let subarr = item.split("=")
      obj[subarr[0]] = subarr[1]
    })
  }
  return obj
}
